"use client";

import React from "react";
import { Skeleton } from "@/components/ui/adapters";

/** Skeleton matching maintenance page layout: two columns, same wrappers. */
export function MaintenancePageSkeleton(): React.ReactElement {
  return (
    <div className="min-h-dvh flex flex-col items-center justify-center bg-background-light px-4 py-8">
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col md:grid md:grid-cols-2 gap-6 md:gap-8 lg:gap-12 items-center md:items-start">
          <div className="flex flex-col items-center justify-center w-full md:max-w-lg md:mx-auto">
            <div className="mb-6 md:mb-8 flex justify-center max-w-xs md:max-w-md w-full">
              <Skeleton className="w-full aspect-square max-w-[280px] rounded-2xl bg-secondary-light/90" />
            </div>
            <Skeleton className="h-8 w-64 mb-2 md:mb-3 rounded-xl bg-secondary-light/90" />
            <div className="text-center mb-6 md:mb-8 px-2 flex flex-col gap-2 w-full max-w-md">
              <Skeleton className="h-4 w-full rounded-lg bg-secondary-light/80" />
              <Skeleton className="h-4 w-full rounded-lg bg-secondary-light/80" />
              <Skeleton className="h-4 w-3/4 rounded-lg bg-secondary-light/80" />
            </div>
            <Skeleton className="min-w-[200px] h-12 w-full sm:w-48 rounded-xl bg-secondary-light/90" />
          </div>
          <div className="w-full h-full flex flex-col items-center justify-center md:items-start">
            <div className="w-full max-w-full md:max-w-lg lg:max-w-xl text-center">
              <Skeleton className="w-full h-[400px] md:h-[700px] rounded-xl bg-secondary-light/80" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
